import { messages } from "../../lib/messages";
import type { Category } from "../../api/catalog";

interface CategoryChipsProps {
  categories: Category[];
  activeCategoryId: string | undefined;
  onSelect(categoryId: string | undefined): void;
}

/**
 * CategoryChips — горизонтальный скролл чипсов разделов витрины (docs/07-miniapp-ux.md §2.2).
 * «Все» — синтетический локальный пункт, серверу не соответствует.
 */
export function CategoryChips({ categories, activeCategoryId, onSelect }: CategoryChipsProps) {
  return (
    <div className="flex gap-2 overflow-x-auto px-4 pb-2" role="group" aria-label="Категории">
      <Chip label={messages.allCategories} active={activeCategoryId === undefined} onClick={() => onSelect(undefined)} />
      {categories.map((category) => (
        <Chip
          key={category.id}
          label={category.title}
          active={activeCategoryId === category.id}
          onClick={() => onSelect(category.id)}
        />
      ))}
    </div>
  );
}

function Chip({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={`shrink-0 rounded-full px-3 py-1.5 text-sm ${
        active ? "bg-button text-button-text" : "bg-surface text-text"
      }`}
    >
      {label}
    </button>
  );
}
